<template>
    <div class="navbar-pp">
        <b-navbar fixed="top" toggleable="lg">
            <div class="container">
                <b-navbar-brand>
                    <router-link :to="isAdmin ? '/admin/plataforma-adm' : '/'">
                        <img :src="require('@/assets/logo-ppp2.png')" style="height: 56px;" alt="pp-logo"
                    /></router-link>
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav class="mr-auto">
                        <slot name="first-items"></slot>
                        <slot name="left-items"></slot>
                        <slot name="left-items-logged"></slot>
                    </b-navbar-nav>

                    <b-navbar-nav class="mr-auto">
                        <slot name="items-link"></slot>
                        <slot name="items-link-logged"></slot>
                    </b-navbar-nav>

                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto right-buttons">
                        <span class="navbar-text">
                            <ThemeButton
                                :is-sun-button="getIsChecked"
                                @click="changeToDarkTheme($event)"
                                v-if="false"
                            />
                        </span>

                        <slot name="right-buttons"></slot>
                        <slot name="right-buttons-logged"></slot>
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import ThemeButton from '@/components/theme-button/ThemeButton'

export default {
    name: 'NavBarPP',
    components: { ThemeButton },
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isChecked: this.$store.state.darkTheme
        }
    },
    computed: {
        getIsChecked() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['changeTheme']),
        changeToDarkTheme(value) {
            this.changeTheme(value)
        }
    }
}
</script>

<style scope src="./NavBarPP-light-theme.css"></style>
<style scope src="./NavBarPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/navbar-pp/NavBarPP.vue